export const languageOptions = [
  { value: 'Afrikaans', label: 'Afrikaans' },
  { value: 'Arabic', label: 'العربية' },
  { value: 'Armenian', label: 'Հայերեն' },
  { value: 'Azerbaijani', label: 'Azərbaycan dili' },
  { value: 'Belarusian', label: 'Беларуская' },
  { value: 'Bosnian', label: 'Bosanski' },
  { value: 'Bulgarian', label: 'Български' },
  { value: 'Catalan', label: 'Català' },
  { value: 'Chinese', label: '中文' },
  { value: 'Croatian', label: 'Hrvatski' },
  { value: 'Czech', label: 'Čeština' },
  { value: 'Danish', label: 'Dansk' },
  { value: 'Dutch', label: 'Nederlands' },
  { value: 'English', label: 'English' },
  { value: 'Estonian', label: 'Eesti' },
  { value: 'Finnish', label: 'Suomi' },
  { value: 'French', label: 'Français' },
  { value: 'Galician', label: 'Galego' },
  { value: 'German', label: 'Deutsch' },
  { value: 'Greek', label: 'Ελληνικά' },
  { value: 'Hebrew', label: 'עברית' },
  { value: 'Hindi', label: 'हिन्दी' },
  { value: 'Hungarian', label: 'Magyar' },
  { value: 'Icelandic', label: 'Íslenska' },
  { value: 'Indonesian', label: 'Bahasa Indonesia' },
  { value: 'Italian', label: 'Italiano' },
  { value: 'Japanese', label: '日本語' },
  { value: 'Kannada', label: 'ಕನ್ನಡ' },
  { value: 'Kazakh', label: 'Қазақ тілі' },
  { value: 'Korean', label: '한국어' },
  { value: 'Latvian', label: 'Latviešu' },
  { value: 'Lithuanian', label: 'Lietuvių' },
  { value: 'Macedonian', label: 'Македонски' },
  { value: 'Malay', label: 'Bahasa Melayu' },
  { value: 'Marathi', label: 'मराठी' },
  { value: 'Maori', label: 'Māori' },
  { value: 'Nepali', label: 'नेपाली' },
  { value: 'Norwegian', label: 'Norsk' },
  { value: 'Persian', label: 'فارسی' },
  { value: 'Polish', label: 'Polski' },
  { value: 'Portuguese', label: 'Português' },
  { value: 'Romanian', label: 'Română' },
  { value: 'Russian', label: 'Русский' },
  { value: 'Serbian', label: 'Српски' },
  { value: 'Slovak', label: 'Slovenčina' },
  { value: 'Slovenian', label: 'Slovenščina' },
  { value: 'Spanish', label: 'Español' },
  { value: 'Swahili', label: 'Kiswahili' },
  { value: 'Swedish', label: 'Svenska' },
  { value: 'Tagalog', label: 'Tagalog' },
  { value: 'Tamil', label: 'தமிழ்' },
  { value: 'Thai', label: 'ไทย' },
  { value: 'Turkish', label: 'Türkçe' },
  { value: 'Ukrainian', label: 'Українська' },
  { value: 'Urdu', label: 'اردو' },
  { value: 'Vietnamese', label: 'Tiếng Việt' },
  { value: 'Welsh', label: 'Cymraeg' },
]

export const localeToLanguageMap: Record<string, string> = {
  en: 'English',
  ja: 'Japanese',
  vi: 'Vietnamese',
}

export const getLanguageFromLocale = (locale?: string): string => {
  if (!locale) return 'English'
  return localeToLanguageMap[locale] || 'English'
}

export const getLanguageLabel = (val: string) =>
  languageOptions.find((o) => o.value === val)?.label || val


export const LANGUAGE_VALUES = languageOptions.map((o) => o.value) as [
  (typeof languageOptions)[number]['value'],
  ...(typeof languageOptions)[number]['value'][],
]

export type RealtimeVoiceLanguage = (typeof LANGUAGE_VALUES)[number]

export const REALTIME_VOICE_LANGUAGE = 'realtimeVoiceLanguage'
